<template>
  <div class="home">
    <banner-Component></banner-Component>
    <div class="main">
<!--    关于镇明转轴-->
      <div class="about">
          <div class="content">
              <div class="left wow">
              <div class="one">
                <div class="l">
                    <img src="../assets/zm/home/dot.png" alt="">
                </div>
                  <div class="r">
                      <img src="../assets/zm/home/zm.png" alt="">
                      <span @click="playVideo">
                          <i class="iconfont icon-bofang"></i>
                      </span>
                  </div>
              </div>
                  <div class="two" :class="{Run:active}">
                      <img src="../assets/zm/home/ab.png" alt="">
                  </div>
                  <div class="three">
                      <div></div>
                      <p>{{$t('home').about.text0}}</p>
                  </div>
              </div>
              <div class="right wow">
                  <p>{{$t('home').about.text1}}</p>
                  <p>{{$t('home').about.text2}}</p>
                  <homeDia class="dia" />
                  <div class="detail" @click="gotoAbout">
                      {{$t('btn')}}
                      <span>
                                      <i class="iconfont icon-top-line"></i>
                                  </span>
                  </div>
                  <div class="im">
                      <img src="../assets/zm/home/DSC_1697.png" alt="">
                  </div>
              </div>
          </div>
      </div>

<!--        汽车电机轴-->
      <div class="car " @click="gotoList(pList[0].ID)">
          <img class="wow" :src="`http://www.zhenming.com/upload/${pList[0].BIGIMG}`" alt="">
          <div class="aCon">
              <div class="content wow fadeIn">
                  <p>{{pList[0].CALLED}}</p>
                  <p>{{pList[0].JS}}</p>
                  <div class="detail">
                      {{$t('btn2')}}
                      <span>
                                      <i class="iconfont icon-top-line"></i>
                                  </span>
                  </div>
              </div>
          </div>
      </div>

<!--        工业电机轴&新能源轴-->
       <div class="pros">
      <div class="industry wow" @click="gotoList(pList[1].ID)">
          <img :src="`http://www.zhenming.com/upload/${pList[1].BIGIMG}`" alt="">
          <div class="aCon">
              <div class="content wow fadeIn">
                  <p>{{pList[1].CALLED}}</p>
                  <p>{{pList[1].JS}}</p>
                  <div class="detail">
                      {{$t('btn2')}}
                      <span>
                                      <i class="iconfont icon-top-line"></i>
                                  </span>
                  </div>
              </div>
          </div>
      </div>
           <div class="ele wow" @click="gotoList(pList[2].ID)">
               <img :src="`http://www.zhenming.com/upload/${pList[2].BIGIMG}`" alt="">
               <div class="aCon">
                   <div class="content wow fadeIn">
                       <p>{{pList[2].CALLED}}</p>
                       <p>{{pList[2].JS}}</p>
                       <div class="detail">
                           {{$t('btn2')}}
                           <span>
                                      <i class="iconfont icon-top-line"></i>
                                  </span>
                       </div>
                   </div>
               </div>
           </div>
       </div>

<!--        新闻资讯-->
       <div class="news">
        <div class="title wow fadeInLeft">
        <p>{{$t('home').news.text0}}</p>
            <p>{{$t('home').news.text1}}</p>
        </div>
           <div class="content wow fadeInRight">
          <div class="link">
              <a href="./news.html">{{$t('home').news.text2}}/</a>
              <a href="./news.html?index=0">{{$t('home').news.text3}}/</a>
              <a href="./news.html?index=1">{{$t('home').news.text4}}</a>
          </div>
               <div class="allNews">
                   <swiper class="swiper" :options="swiperOption" ref="mySwiper"  v-if="nList.length>0">
                       <swiper-slide class="item" v-for="(item,index) in nList" :key="index" >
                        <div class="l" @click="gotoInfo(item.ID)">
                            <img :src="`http://www.zhenming.com/upload/${item.SMALLPIC}`" alt="">
                        </div>
                           <div class="r" @click="gotoInfo(item.ID)">
                               <p>{{item.TITLE}}</p>
                               <p>{{item.INTRO}}</p>
                               <div class="detail">
                                   {{$t('btn3')}}
                                   <span>
                                      <i class="iconfont icon-top-line"></i>
                                  </span>
                               </div>
                           </div>
                       </swiper-slide>
                   </swiper>
                   <div class="prev">
                       <i class="el-icon-arrow-left"></i>
                   </div>
                   <div class="next ">
                       <i class="el-icon-arrow-right"></i>
                   </div>
               </div>
           </div>
       </div>

<!--        下一篇-->
        <div class="nextNews wow fadeInUp" @click="gotoInfo(nList2.ID)">
         <div class="left">
             <img :src="`http://www.zhenming.com/upload/${nList2.SMALLPIC}`" alt="">
         </div>
            <div class="right">
            <p>{{$t('home').news.text5}}</p>
                <p>{{nList2.TITLE}}</p>
                <p>{{nList2.INTRO}}</p>
            </div>
        </div>

    </div>
      <div class="video-full"   :class="{ showVideo }" >
          <div class="video-content">
              <div class="video-close"
                   @click="pauseVideo">
                  <i class="el-icon-close"></i>
              </div>
              <video
                      id="videoPlay01"
                      controls="controls"
                      style="z-index: 3000">
                  <source
                          type="video/mp4;"
                          src="https://www.sansg.com/video/zm.mp4"
                          data-src="https://www.sansg.com/video/zm.mp4">

                  你的浏览器不支持
                  <code>video</code> 标签.
              </video>
          </div>
      </div>
      <foot-Component class="foot wow"></foot-Component>
  </div>
</template>

<script>
  import bannerComponent from '../components/banner'
  import Scrollbar from 'smooth-scrollbar'
  import homeDia from "../components/homeDia";
  import { swiper, swiperSlide } from "vue-awesome-swiper";
  import "swiper/dist/css/swiper.css";
  import footComponent from '../components/foot'
  import {getProductstypeUrl2,getNewsUrl} from '../util/lang'
export default {
  name: 'home',
    data(){
      let _this=this
      return{
          active:false,
          showVideo:false,
          pList:[
              {   ID:'',
                  BIGIMG:'',
                  CALLED:'',
                  JS:''
              },
              {   ID:'',
                  BIGIMG:'',
                  CALLED:'',
                  JS:''
              },
              {   ID:'',
                  BIGIMG:'',
                  CALLED:'',
                  JS:''
              }
          ],
          nList:[],
          scrollbar:'',
          top:'',
          nList2:{
              TITLE:'',
              SMALLPIC:'',
              INTRO:''
          },
          swiperOption:{
              notNextTick: true,
              slidesPerView: 1,
              speed:1000,
              init:false,
              spaceBetween : 10,
              loop:false,
              autoplay:false,
              setWrapperSize :true,
              on: {
                  slideChangeTransitionEnd: () => {
                      this.$nextTick(() => {
                          let swiper = this.$refs.mySwiper.swiper;
                          let active = swiper.realIndex;
                          if((active+1)<_this.nList.length){
                              _this.nList2=_this.nList[active+1]
                          }else{
                              _this.nList2=_this.nList[active]
                          }

                          // console.log(_this.nList)
                      });
                  }
              },
              navigation: {
                  nextEl: '.allNews .next',
                  prevEl: '.allNews .prev'
              }
          },
      }
    },
    mounted() {
        Scrollbar.initAll(document.getElementById("scroller-wrapper"));
        let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
        scrollbar.scrollTo(0,0)
        this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
        window.pageYOffset=this.scrollbar.scrollTop
        this.scrollbar.addListener((status) => {
            if(status.offset.y>500 && status.offset.y<1000)
            {
                this.active=true
            }else{
                this.active=false
            }
        });
        setTimeout(()=>{
            if(this.$i18n.locale==='zh-CN'){
                this.getPro('42')
                this.getNews('26')
            }else{
                this.getPro('47')
                this.getNews('33')
            }
        },100)
        // this.$nextTick(()=>{
        //
        // })
    },
  components:{bannerComponent,footComponent,swiper, swiperSlide,homeDia},
    methods:{
        pauseVideo(){
            const audioPlayer = window.document.getElementById('videoPlay01');
            audioPlayer.pause();
            this.showVideo=false
            this.$emit('menushow',this.showVideo)
            setTimeout(()=>{
                this.scrollbar.scrollTo(0,this.top)
            },100)

        },
        playVideo(){
            this.top=this.scrollbar.scrollTop
            const audioPlayer = window.document.getElementById('videoPlay01');
            audioPlayer.load();
            this.scrollbar.scrollTo(0,0)
            audioPlayer.play();
            this.showVideo=true
            this.$emit('menushow',this.showVideo)
        },
        gotoList(n){
            const  link=`/proList.html?id=${n}`
            window.open(link,'_self')
        },
        getNews(id){
            const url = `${getNewsUrl(this.$i18n.locale,id,10000,1)}`
            this.$axios.get(url).then(res => {
                res.data.newsArr.map((item)=>{
                    item.SHOWTIME=item.SHOWTIME.slice(0,11)
                    if(item.ISCOMMEND=='1'){
                        this.nList.push(item)
                    }
                })
                this.nList2=this.nList[1]
                setTimeout(()=>{
                    this.$refs.mySwiper.swiper.init()
                },100)
            })
        },
        getPro(id){
            this.$nextTick(()=>{
                let arr=[]
                const url = `${getProductstypeUrl2(this.$i18n.locale,id)}`
                this.$axios.get(url).then(res => {
                    res.data.map((item)=>{
                        if(item.ISHOME=='1'){
                            arr.push(item)
                        }
                    })
                    this.pList=arr
                })
            })
        },
      gotoInfo(id){
          const link=`/newsInfo.html?id=${id}`
          window.open(link,'_blank')
      },
        gotoAbout(){
            const link='/about.html'
            window.open(link,'_self')
        }
    }
}
</script>

<style lang="scss" scoped>
.home{
  width:100%;
    animation: run5 1s linear forwards;
    @keyframes run5 {
        from{
            opacity: 0;
        }
        to{
            opacity: 1;
        }
    }
  .main{
    width:100%;
      .about{
          width:100%;
          height:1000px;
          background: url("../assets/zm/home/abg.png") no-repeat;
          background-size: cover;
          .content{
              width:1440px;
              margin: 0 auto;
              padding: 60px 0;
              display: flex;
              flex-direction: row;
              .left{
                  width:45%;
                  position: relative;
                  animation:transition1 2s forwards ease-in ;
                  .one{
                      width:100%;
                      position: absolute;
                      top:60px;
                      left:0;
                      display: flex;
                      flex-direction: row;
                      justify-content: flex-end;
                      align-items: center;
                      z-index: 100;
                      .l{
                          margin-right: 20px;
                      }
                      .r{
                          position: relative;
                          cursor: pointer;
                          span{
                              display: inline-block;
                              position: absolute;
                              left:45%;
                              top:35%;
                              height:66px;
                              width:66px;
                              i{
                                  color:rgba(255,255,255,.6);
                                  font-size: 60px;
                              }
                              &::after{
                                  content: "";
                                  position: absolute;
                                  width: 100%;
                                  height: 100%;
                                  top: -2px;
                                  left: -5px;
                                  pointer-events: none;
                                  background-color: transparent;
                                  border-style: solid;
                                  border-width: 2px;
                                  border-color: rgba(255, 255, 255, 0.5);
                                  border-radius: 50%;
                                  opacity: 0;
                                  transition: opacity 0.3s,transform 0.5s;
                              }
                          }
                          &:hover{
                              span::after{
                                  opacity: 1;
                                  transform: scale(1.2);
                                  -webkit-transform: scale(1.2);
                              }
                          }
                      }
                  }
                  .two{
                      width:100%;
                      position: absolute;
                      top:320px;
                      left: -112px;
                      transition: all 2s;
                  }
                  .Run{
                      animation: go 2s forwards linear;
                  }
                  @keyframes go {
                      0%{
                          left: -112px;
                      }
                      25%{
                          left:-140px;
                      }
                      50%{
                          left:-160px;
                      }
                      75%{
                          left:-140px;
                      }
                     100%{
                         left: -112px;
                     }
                  }
                  .three{
                      position: absolute;
                      bottom:15%;
                      left:0;
                      width:90%;
                      display: flex;
                      flex-direction: row;
                      justify-content: flex-end;
                      align-items: center;
                      div{
                          width:247px;
                          height:1px;
                          background:rgba(243,112,65,1);
                      }
                      p{
                          font-size: 18px;
                          font-family: "Fira Code Light";
                          font-weight: lighter;
                          margin-left: 30px;
                      }
                  }
              }
              .right{
                  width:55%;
                  padding-left: 20px;
                  animation:transition2 2s forwards ease-in ;
                  p{
                      width:90%;
                  }
                  p:nth-child(1){
                      color:#2F2F2F;
                      font-size: 30px;
                      font-weight: bold;
                  }
                  p:nth-child(2){
                      color:#D3D6D9;
                      font-family: "Fira Code Light";
                      font-weight: lighter;
                      margin: 5px 0;
                  }
                  .dia{
                      margin: 30px 0;
                      width:90%;
                  }
                 .detail{
                      font-family: "Fira Code Light";
                      font-weight: lighter;
                      font-size: 14px;
                     margin: 30px 0;
                     margin-right: 10px;
                     width:90%;
                     display: flex;
                     flex-direction: row;
                     justify-content: flex-end;
                     cursor: pointer;
                      span{
                          width:20px;
                          height:20px;
                          background:linear-gradient(-90deg,rgba(197,74,30,1),rgba(244,128,87,1));
                          border:1px solid rgba(223, 88, 39, 1);
                          box-shadow:0px 2px 6px 0px rgba(0, 0, 0, 0.3);
                          border-radius:50%;
                          display: inline-block;
                          transform: rotate(90deg);
                          text-align: center;
                          margin-left: 10px;
                          transition: all 1s;
                          i{
                              color:white;
                              font-size: 14px;
                          }
                      }
                     &:hover{
                         span{
                             margin-left: 30px;
                         }
                     }
                  }
                  .im{
                      width:100%;
                      overflow: hidden;
                      cursor: pointer;
                      margin: 58px auto;
                      margin-left: -50px;
                      img{
                          width:100%;
                          display: block;
                          object-fit: cover;
                          transition: all 2s;
                      }
                      &:hover{
                          img{
                               transform: rotateY(360deg);
                          }
                      }
                  }
              }
          }
      }
      .car{
          width: 100%;
          /*background: url("../assets/zm/home/car.png") no-repeat;*/
          /*background-size: cover;*/
          /*height:737px;*/
          cursor: pointer;
          position: relative;
          img{
              width:100%;
              object-fit: cover;
              display: block;
              animation-name: polygon;
              animation-duration: 2s;
          }
          .aCon{
              width:100%;
              position: absolute;
              left:0;
              top:0;
              .content{
                  width:1440px;
                  margin: 0 auto;
                  animation-duration: 2s;
                  animation-delay: 1.5s;
                  p:nth-child(1){
                      color:#383838;
                      font-size: 50px;
                      padding-top: 150px;
                      margin-bottom: 50px;
                      transition: all 1s;
                  }
                  p:nth-child(2){
                      color:#4B4B4B;
                      font-family: "Fira Code Light";
                      font-weight: lighter;
                      line-height: 32px;
                      width:38%;
                  }
                  .detail{
                      font-family: "Fira Code Light";
                      font-weight: lighter;
                      font-size: 14px;
                      display: flex;
                      width:38%;
                      margin: 60px 0;
                      flex-direction: row;
                      justify-content: flex-end;
                      span{
                          width:20px;
                          height:20px;
                          background:linear-gradient(-90deg,rgba(197,74,30,1),rgba(244,128,87,1));
                          border:1px solid rgba(223, 88, 39, 1);
                          box-shadow:0px 2px 6px 0px rgba(0, 0, 0, 0.3);
                          border-radius:50%;
                          display: inline-block;
                          transform: rotate(90deg);
                          text-align: center;
                          margin-left: 10px;
                          transition: all 1s;
                          i{
                              color:white;
                              font-size: 14px;
                          }
                      }
                  }
                  &:hover{
                      p:nth-child(1){
                          color: #F37041;
                      }
                      .detail{
                          span{
                              margin-left: 20px;
                          }
                      }
                  }
              }
          }
      }
      .pros{
          width:100%;
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-top: 10px;
          .industry{
              width:50%;
              animation-name: polygon2;
              animation-duration: 2s;
              cursor: pointer;
              position: relative;
              img{
                  width:100%;
                  object-fit: cover;
                  display: block;
                  height:600px;
              }
              .aCon{
                  width:100%;
                  position: absolute;
                  left:0;
                  top:0;
                  .content{
                      width:80%;
                      margin-left: 10%;
                      text-align: right;
                      animation-duration: 2s;
                      animation-delay: 2s;
                      p:nth-child(1){
                          color:#383838;
                          font-size: 50px;
                          padding-top: 100px;
                          padding-bottom: 30px;
                          transition: all 1s;
                      }
                      p:nth-child(2){
                          color:#4B4B4B;
                          font-family: "Fira Code Light";
                          font-weight: lighter;
                          line-height: 32px;
                          width:80%;
                          margin-left: 20%;
                      }
                      .detail{
                          font-family: "Fira Code Light";
                          font-weight: lighter;
                          font-size: 14px;
                          display: flex;
                          width:80%;
                          margin: 60px 20%;
                          flex-direction: row;
                          justify-content: flex-end;
                          span{
                              width:20px;
                              height:20px;
                              background:linear-gradient(-90deg,rgba(197,74,30,1),rgba(244,128,87,1));
                              border:1px solid rgba(223, 88, 39, 1);
                              box-shadow:0px 2px 6px 0px rgba(0, 0, 0, 0.3);
                              border-radius:50%;
                              display: inline-block;
                              transform: rotate(90deg);
                              text-align: center;
                              margin-left: 10px;
                              transition: all 1s;
                              i{
                                  color:white;
                                  font-size: 14px;
                              }
                          }
                      }
                  }
                  &:hover{
                      .content{
                          p:nth-child(1){
                              color: #F37041;
                          }
                          .detail{
                              span{
                                  margin-left: 30px;
                              }
                          }
                      }
                  }
              }
          }
          .ele{
              width:50%;
              margin-left: 10px;
              animation-name: polygon2;
              animation-duration: 2s;
              animation-delay: 0.4s;
              cursor: pointer;
              position: relative;
              img{
                  width:100%;
                  object-fit: cover;
                  display: block;
                  height:600px;
              }
              .aCon{
                  width:100%;
                  position: absolute;
                  left:0;
                  top:0;
                  .content{
                      width:80%;
                      margin-left: 10%;
                      animation-duration: 2s;
                      animation-delay: 2s;
                      p:nth-child(1){
                          color:#383838;
                          font-size: 50px;
                          padding-top: 100px;
                          padding-bottom: 30px;
                          transition: all 1s;
                      }
                      p:nth-child(2){
                          color:#4B4B4B;
                          font-family: "Fira Code Light";
                          font-weight: lighter;
                          line-height: 32px;
                          width:50%;
                      }
                      .detail{
                          font-family: "Fira Code Light";
                          font-weight: lighter;
                          font-size: 14px;
                          display: flex;
                          width:80%;
                          margin: 60px 0;
                          flex-direction: row;
                          span{
                              width:20px;
                              height:20px;
                              background:linear-gradient(-90deg,rgba(197,74,30,1),rgba(244,128,87,1));
                              border:1px solid rgba(223, 88, 39, 1);
                              box-shadow:0px 2px 6px 0px rgba(0, 0, 0, 0.3);
                              border-radius:50%;
                              display: inline-block;
                              transform: rotate(90deg);
                              text-align: center;
                              margin-left: 10px;
                              transition: all 1s;
                              i{
                                  color:white;
                                  font-size: 14px;
                              }
                          }
                      }
                  }
                  &:hover{
                      .content{
                          p:nth-child(1){
                              color: #F37041;
                          }
                          .detail{
                              span{
                                  margin-left: 30px;
                              }
                          }
                      }
                  }
              }
          }
      }
      .news{
          width:100%;
          display: flex;
          flex-direction: row;
          .title{
              width:15%;
              padding: 30px 0;
              background-color: #EDEDED;
              position: relative;
              p:nth-child(1){
                  writing-mode:vertical-lr;
                  font-size: 30px;
                  font-weight: bolder;
                  position: absolute;
                  left:50%;
                  top:30px;
              }
              p:nth-child(2){
                  font-family: dusha;
                  color:#A8A8A8;
                  font-size: 60px;
                  text-transform: uppercase;
                  writing-mode:vertical-lr;
                  position: absolute;
                  left:25%;
                  top:30px;
              }
          }
          .content{
              width:80%;
              margin-left: 2%;
             padding: 60px 0;
              .link{
                  width:100%;
                  display: flex;
                  flex-direction: row;
                  a{
                      font-family: "Fira Code Light";
                      font-weight: lighter;
                      letter-spacing: 1px;
                      transition: all 1s;
                      &:hover{
                          color:#F37041;
                      }
                  }
              }
              .allNews{
                  width:90%;
                  margin: 60px 0;
                  margin-left: 2.5%;
                  position: relative;
                  .swiper{
                      .item{
                          display: flex;
                          flex-direction: row;
                          cursor: pointer;
                          .l{
                              width:35%;
                              overflow: hidden;
                              img{
                                  width:100%;
                                  display: block;
                                  object-fit: cover;
                                  transition: all 1s;
                              }
                          }
                          .r{
                              width:62%;
                              margin-left: 3%;
                              p:nth-child(1){
                                  margin: 20px auto;
                                  font-size: 22px;
                                  font-weight: bolder;
                                  transition: all 1s;
                              }
                              p:nth-child(2){
                                  font-family: "Fira Code Light";
                                  font-weight: lighter;
                                  font-size: 14px;
                                  line-height: 30px;
                                  margin: 10px auto;
                                  display: -webkit-box;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 4;
                                  overflow: hidden;
                              }
                              .detail{
                                  font-family: "Fira Code Light";
                                  font-weight: lighter;
                                  font-size: 14px;
                                  display: flex;
                                  flex-direction: row;
                                 margin-top: 60px;
                                  span{
                                      width:20px;
                                      height:20px;
                                      background:linear-gradient(-90deg,rgba(197,74,30,1),rgba(244,128,87,1));
                                      border:1px solid rgba(223, 88, 39, 1);
                                      box-shadow:0px 2px 6px 0px rgba(0, 0, 0, 0.3);
                                      border-radius:50%;
                                      display: inline-block;
                                      transform: rotate(90deg);
                                      text-align: center;
                                      margin-left: 10px;
                                      transition: all 1s;
                                      i{
                                          color:white;
                                          font-size: 14px;
                                      }
                                  }
                              }
                          }
                          &:hover{
                              .l{
                                  img{
                                      transform: scale(1.05);
                                  }
                              }
                              .r{
                                  p:nth-child(1){
                                      color:#F37041;
                                  }
                                  .detail{
                                      span{
                                          margin-left: 30px;
                                      }
                                  }
                              }
                          }
                      }
                  }
                  .prev{
                      position: absolute;
                      right:10%;
                      bottom:5%;
                      z-index: 100;
                      padding: 5px 5px;
                      transition: all 1s;
                      cursor: pointer;
                      z-index: 100;
                      i{
                          transition: all 1s;
                          font-size: 20px;
                      }
                      &:focus{
                          outline: none;
                      }
                      &:hover{
                          background-color: #F37041;
                          i{
                              color:white;
                          }
                      }
                  }
                  .next{
                      @extend .prev;
                      right:3%;
                      left:auto;
                      &::before{
                          content:'';
                          display: inline-block;
                          width:1px;
                          height:22px;
                          background:rgba(77,77,77,.4);
                          position: absolute;
                          left:-33px;
                          top:4px;
                      }
                  }
              }
          }
      }
      .nextNews{
          width:100%;
          display: flex;
          flex-direction: row;
          margin-bottom: 30px;
          .left{
              width:30%;
              overflow: hidden;
              cursor: pointer;
              img{
                  width:100%;
                  object-fit: cover;
                  display: block;
                  transition: all 1s;
                  height:100%;
              }
              &:hover{
                  img{
                      transform: scale(1.05);
                  }
              }
          }
          .right{
              width:70%;
              background-color: #EDEDED;
              p{
                  width:80%;
                  margin-left: 5%;
              }
              p:nth-child(1){
                  font-size: 14px;
                  font-family: "Fira Code Light";
                  font-weight: lighter;
                  padding: 40px 0;
              }
              p:nth-child(2){
                  font-size: 18px;
                  font-weight: bolder;
              }
              p:nth-child(3){
                  margin: 20px 5%;
                  font-size: 14px;
                  font-family: "Fira Code Light";
                  font-weight: lighter;
                  color:#010101;
                  line-height: 35px;
              }
          }
      }
  }
  .foot{
    animation-name: polygon;
    animation-duration: 2s;
  }
  @keyframes transition1 {
    0% {
      transform: translate(-100px,100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes transition2 {
    0% {
      transform: translate(100px,-100px);
      opacity: 0;
    }
    100% {
      transform: translate(0,0);
      opacity: 1;
    }
  }
  @keyframes polygon {
    0% {
      clip-path: polygon(0% 0%, 0% 100%, 0% 100%, 0% 0%);
    }
    100% {
      clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
    }
  }
    @keyframes polygon2 {
        0% {
            clip-path: polygon(0% 0%, 100% 0%, 1000% 0%, 0% 0%);
        }
        100% {
            clip-path: polygon(0% 0%, 0% 100%, 100% 100%, 100% 0%);
        }
    }
  @media screen  and (min-width: 2200px){

  }
  @media screen and (max-width: 1440px){
   .main{
       .about{
           .content{
               width:90%;
           }
       }
       .car{
           .aCon{
               .content{
                   width:90%;
               }
           }
       }
       .news{
           .content{
               .allNews{
                   .prev{
                       right:12%;
                   }
                   .next{
                       right:3%;
                   }
               }
           }
       }
   }
  }
  @media screen and (max-width: 1000px){
   .main{
       .about{
           .content{
               flex-direction: column;
               .left,.right{
                   width:100%;
               }
               .left{
                   .one{
                       .l{
                           margin-right: 0;
                           img{
                               width:100%;
                               object-fit: cover;
                           }
                       }
                       .r{
                           img{
                               width:100%;
                               object-fit: cover;
                           }
                           span{
                               left: 43%;
                               top: 32%;
                           }
                       }
                   }
                   .two{
                       display: none;
                   }
                   .three{
                       div{
                           width:120px;
                       }
                       p{
                           font-size: 14px;
                           margin-left: 0;
                       }
                   }
                   .one,.two,.three{
                       position: static;
                   }
               }
               .right{
                   padding-left: 0;
                   margin-top: 30px;
                   p,.dia,.detail{
                       width:100%;
                   }
                   .im{
                       margin-left: 0;
                   }
               }
           }
       }
       .car{
           img{
               height:500px;
           }
           .aCon{
               .content{
                   p:nth-child(1){
                       padding-top: 40px;
                       font-size: 30px;
                   }
                   p:nth-child(2){
                       width:100%;
                   }
               }
           }
       }
       .pros{
           flex-direction: column;
           .industry,.ele{
               width:100%;
               margin-left: 0;
               img{
                   height:500px;
               }
               .aCon{
                   .content{
                       p:nth-child(1){
                           font-size: 30px;
                       }
                       p:nth-child(2){
                           width:80%;
                       }
                   }
               }
           }
       }
       .news{
        .title{
            width:25%;
            p:nth-child(2){
                left:-3%;
            }
        }
           .content{
               width:67%;
               margin-left: 3%;
               padding-top: 30px;
               .allNews{
                   margin: 30px auto;
                   width:100%;
                   .swiper{
                       .item{
                           flex-direction: column;
                           .l,.r{
                               width:100%;
                           }
                           .r{
                               p:nth-child(1){
                                   font-size: 16px;
                                   margin: 10px auto;
                               }
                               p:nth-child(2){
                                   font-size: 13px;
                               }
                           }
                       }
                   }
                   .prev{
                       right:20%;
                   }
                   .next{
                       right:3%;
                   }
                   .next::before{
                       left:-57px;
                   }
               }
           }
       }
       .nextNews{
           flex-direction: column;
           .left,.right{
               width:100%;
           }
           .right{
               p:nth-child(1){
                   padding: 20px 0;
               }
               p:nth-child(3){
                   margin: 10px 5%;
               }
           }
       }
   }
  }
}
</style>
<style scoped>
    video{
        border: none;
    }
    video:focus{
        outline: none;
    }
    .video-full {
        display: none;
    }
    .video-full.showVideo {
        display: block;
        position: fixed;
        top:0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.9);
        z-index: 10000;
    }
    .video-bg {
    }
    .video-close {
        cursor: pointer;
        position: absolute;
        top: 10%;
        right: 20%;
        z-index: 3200;
    }
    .video-close i {
        transition: opacity 0.4s ease-in-out;
        font-size: 50px;
        color: #fff;
    }
    .video-content {
        margin: 150px auto;
        z-index: 3000;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1024px;
        min-height: 500px;
        max-height: 90vh;
    }
    .video-content video {
        width: 100%;
        height: 100%;
    }
    @media screen and (max-width: 1680px){
        .video-content{
          max-height: 350px;
            min-height: 400px;
        }
    }
    @media screen and (max-width: 1440px){
        .video-content{
            min-height: 500px;
            max-height: 90vh;
            margin: 100px auto;
            margin-bottom: 0;
            width:80%;
        }
        .video-close{
            top:5%;
            right:10%;
        }
    }
    /*@media screen and (max-width: 1440px){*/
    /*    .video-content{*/
    /*        width:90%;*/
    /*        margin-top: 0;*/
    /*    }*/
    /*}*/
</style>
